import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

const testimonials = [
  {
    quote: "We have been working with APS for our projects. Their products are reliable and meet all safety standards. Excellent service quality.",
    name: "K V Rao",
    role: "AGM",
    company: "SRR Projects Pvt. Ltd",
  },
  {
    quote: "Your prompt support, proper safety accessories, and responsiveness have contributed positively to smooth site execution. Please continue maintaining the same standards.",
    name: "Faizal Raza",
    role: "Purchase Manager",
    company: "Construction Division",
  },
  {
    quote: "Outstanding scaffolding solutions and professional service. Their team's expertise and commitment to safety standards make them our preferred partner for all projects.",
    name: "Nagendra Rao",
    role: "Scaffolding Division",
    company: "Kalpataru Projects",
  },
];

export default function TestimonialsPage() {
  return (
    <div data-testid="testimonials-page">
      <SEO title="Client Testimonials" description="Read what our clients say about Amar Preet Scaffolding. Trusted by leading contractors, EPC companies and builders across India for 30+ years." canonical="/testimonials" />
      {/* Hero */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" data-testid="testimonials-headline">Client Testimonials</h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            What our clients say about working with us
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-8 md:p-10 border-l-4 border-yellow-500"
                data-testid={`testimonial-${index}`}
              >
                <svg className="w-10 h-10 text-yellow-400 mb-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
                <p className="text-slate-700 text-lg leading-relaxed mb-6 italic">
                  "{item.quote}"
                </p>
                <div>
                  <p className="font-bold text-slate-900">{item.name}</p>
                  <p className="text-sm text-slate-500">{item.role}</p>
                  <p className="text-sm text-yellow-600 font-medium">{item.company}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Want to Share Your Experience?</h2>
          <p className="text-slate-600 mb-8">
            We value your feedback. Share your experience working with us to help others make informed decisions.
          </p>
          <a
            href="mailto:info@amarpreet.in?subject=Client%20Testimonial"
            className="inline-flex items-center bg-yellow-500 hover:bg-yellow-600 text-slate-900 px-8 py-3 rounded-lg font-semibold transition-all hover:scale-105"
            data-testid="submit-review-btn"
          >
            Submit Your Review
            <ArrowRight className="w-5 h-5 ml-2" />
          </a>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-yellow-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            Join Our Growing List of Satisfied Clients
          </h2>
          <p className="text-slate-700 mb-8 max-w-xl mx-auto">
            Get reliable scaffolding solutions backed by 30+ years of experience
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-800 transition-all hover:scale-105"
            data-testid="testimonials-cta"
          >
            Get Free Quote
            <ArrowRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
}
